"use client"

import { FC } from "react"
import type { SearchCategory } from "./types"
import { CategoryRow, CategoryChip } from "./styles"

interface CategoryFilterProps {
  categories: SearchCategory[]
  activeKey: string
  allLabel: string
  onSelect: (key: string) => void
}

const CategoryFilter: FC<CategoryFilterProps> = ({
  categories,
  activeKey,
  allLabel,
  onSelect,
}) => {
  if (categories.length === 0) return null

  return (
    <CategoryRow role="group">
      <CategoryChip
        type="button"
        $active={activeKey === ""}
        onClick={() => onSelect("")}
      >
        {allLabel}
      </CategoryChip>
      {categories.map((category) => (
        <CategoryChip
          key={category.key}
          type="button"
          $active={activeKey === category.key}
          onClick={() => onSelect(category.key)}
        >
          {category.label}
        </CategoryChip>
      ))}
    </CategoryRow>
  )
}

export default CategoryFilter
